import { createBrowserRouter } from "react-router-dom";
import AuthGuard from "../auth/AuthGuard";
import { ErrorLayout } from "../components/ErrorLayout";
import CommonLayout from "../layouts/common/CommonLayout";
import { withErrorBoundary } from "./helpers/withAuth";

// Route domain modules
import { authRoutes } from "./routes/auth.routes";
import { rankingRoutes } from "./routes/ranking.routes";
import { dashboardRoutes } from "./routes/dashboard.routes";
import { platformRoutes } from "./routes/platforms.routes";
import { exploreRoutes } from "./routes/explore.routes";
import { youtubeRoutes } from "./routes/youtube.routes";
import { toolRoutes } from "./routes/tools.routes";
import { itemRoutes } from "./routes/item.routes";
import { boxOfficeRoutes } from "./routes/box-office.routes";
import { topicModelingRoutes } from "./routes/topic-modeling.routes";
import { issuesRoutes } from "./routes/issues.routes";
import { settingsRoutes } from "./routes/settings.routes";
import { ipManagementRoutes, dataMappingRoutes } from "./routes/ip-management.routes";
import {
  userRoutes,
  permissionRoutes,
  roleRoutes,
  teamRoutes,
  auditRoutes,
  monitoringRoutes,
  controlPanelRoutes,
} from "./routes/admin.routes";
import { NotFound } from "../components/NotFound";

const navigation = createBrowserRouter([
  {
    path: "/",
    errorElement: <ErrorLayout />,
    element: (
      <AuthGuard>
        <CommonLayout title="Dashboard" />
      </AuthGuard>
    ),
    children: withErrorBoundary([...rankingRoutes, ...dashboardRoutes]),
  },
  settingsRoutes,
  ...authRoutes,
  userRoutes,
  permissionRoutes,
  roleRoutes,
  teamRoutes,
  platformRoutes,
  ipManagementRoutes,
  dataMappingRoutes,
  monitoringRoutes,
  issuesRoutes,
  itemRoutes,
  exploreRoutes,
  youtubeRoutes,
  auditRoutes,
  toolRoutes,
  boxOfficeRoutes,
  topicModelingRoutes,
  controlPanelRoutes,
  {
    path: "*",
    element: <NotFound />,
    errorElement: <ErrorLayout />,
  },
]);

export default navigation;
